/**
 * @generated SignedSource<<26ce9d779579094b91a48b2ef6e7e945>>
 * @relayHash 0799e7283121eb71f27f154269c35d2f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f082ceabb2a22dad1af827fe35d8b92c3abbe18d26f157a4497a988561a8d8ff

import type { ConcreteRequest, Query } from 'relay-runtime';
export type LicenseStatus = "ACTIVE" | "SUSPENDED" | "UNLICENSED" | "%future added value";
export type GetUserAccessQuery$variables = {
  permissionId: string;
  resourceId: string;
};
export type GetUserAccessQuery$data = {
  readonly confluence_tenantContext: {
    readonly licensedProducts: ReadonlyArray<{
      readonly licenseStatus: LicenseStatus;
      readonly productKey: string;
    }>;
  } | null | undefined;
  readonly permitted: boolean | null | undefined;
};
export type GetUserAccessQuery = {
  response: GetUserAccessQuery$data;
  variables: GetUserAccessQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "permissionId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resourceId"
},
v2 = [
  {
    "concreteType": "ConfluenceTenantContext",
    "kind": "LinkedField",
    "name": "confluence_tenantContext",
    "plural": false,
    "selections": [
      {
        "concreteType": "LicensedProduct",
        "kind": "LinkedField",
        "name": "licensedProducts",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "licenseStatus"
          },
          {
            "kind": "ScalarField",
            "name": "productKey"
          }
        ]
      }
    ]
  },
  {
    "args": [
      {
        "kind": "Variable",
        "name": "permissionId",
        "variableName": "permissionId"
      },
      {
        "kind": "Variable",
        "name": "resourceId",
        "variableName": "resourceId"
      }
    ],
    "kind": "ScalarField",
    "name": "permitted"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GetUserAccessQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GetUserAccessQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "0799e7283121eb71f27f154269c35d2f",
    "id": "f082ceabb2a22dad1af827fe35d8b92c3abbe18d26f157a4497a988561a8d8ff",
    "metadata": {},
    "name": "GetUserAccessQuery",
    "operationKind": "query",
    "text": "query GetUserAccessQuery($resourceId:String!,$permissionId:String!){confluence_tenantContext{licensedProducts{licenseStatus,productKey}},permitted(resourceId:$resourceId,permissionId:$permissionId)}"
  }
};
})();

(node as any).hash = "32bb5d7171ecf6d04700c4e127e76256";

export default node;
